import createIcon from '../../createIcon';

/**
 * @component @name WifiProtectedSetup
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNzA1MSA1LjI5TDE4Ljk5NTEgM0gxMC45OTUxVjExTDEzLjI5NTEgOC43QzE1LjI2NTEgMTAuMTYgMTYuNTQ1MSAxMi40OCAxNi41NDUxIDE1LjEyQzE2LjU0NTEgMTYuNDMgMTYuMjI1MSAxNy42NiAxNS42NjUxIDE4Ljc1QzE3Ljk5NTEgMTcuMjMgMTkuNTQ1MSAxNC42MSAxOS41NDUxIDExLjYyQzE5LjU0NTEgOS4xIDE4LjQzNTEgNi44NSAxNi43MDUxIDUuMjlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNy40NTUwOCA4Ljg4QzcuNDU1MDggNy41NyA3Ljc3NTA4IDYuMzQgOC4zMzUwOCA1LjI1QzUuOTk1MDggNi43NyA0LjQ1NTA4IDkuMzkgNC40NTUwOCAxMi4zOEM0LjQ1NTA4IDE0LjkgNS41NTUwOCAxNy4xNSA3LjI5NTA4IDE4LjcxTDQuOTk1MDggMjFIMTIuOTk1MVYxM0wxMC42OTUxIDE1LjNDOC43MzUwOCAxMy44NCA3LjQ1NTA4IDExLjUyIDcuNDU1MDggOC44OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WifiProtectedSetup = createIcon('WifiProtectedSetup', [
  [
    'path',
    {
      d: 'M16.7051 5.29L18.9951 3H10.9951V11L13.2951 8.7C15.2651 10.16 16.5451 12.48 16.5451 15.12C16.5451 16.43 16.2251 17.66 15.6651 18.75C17.9951 17.23 19.5451 14.61 19.5451 11.62C19.5451 9.1 18.4351 6.85 16.7051 5.29Z',
      key: 'dk644l',
    },
  ],
  [
    'path',
    {
      d: 'M7.45508 8.88C7.45508 7.57 7.77508 6.34 8.33508 5.25C5.99508 6.77 4.45508 9.39 4.45508 12.38C4.45508 14.9 5.55508 17.15 7.29508 18.71L4.99508 21H12.9951V13L10.6951 15.3C8.73508 13.84 7.45508 11.52 7.45508 8.88Z',
      key: '1w8l7f',
    },
  ],
]);

export default WifiProtectedSetup;
